import { Acm } from "app/models/loyalty-acm.model";
import { AccumulatorDTO } from "./levels-creation/levels-creation.component";

//ChallengeResponse
export class ChallengeResponse {
  template: Template;
  userDelId: number;
  numLevel: number;
  description: string;
  flgAgreementRequired: string;
  dateEnd: string;
  flgKf: string;
  title: string;
  tsInsert: string;
  flgState: string;
  dateStart: string;
  conditionBooleanOperator: string;
  flgDeploy: string;
  userInsertId: number;
  id: number;
  tsDel: string | null;
  distributionList: DistributionList;
  flgPreview: string;
  userUpdateId: number;
  flgPushNotification: string;
  agreementClusterHead: AgreementClusterHead;
  challengeType: ChallengeType;
  timeOffset: number | null;
  priority: number;
  tsUpdate: string | null;
  dayOffset: number;
  pushNotificationText: string;
  status: string;
  challengeTypeDescription:string;
  distributionListName:string;
  acceptanceDate: string;
  levelAchievementDate: string;
}

export class Template {
  id: number;
  flgState: string;
  flgKf: string;
  flgDeploy: string;
  tsInsert: string;
  userInsertId: number;
  tsUpdate: string | null;
  userUpdateId: number;
  tsDel: string | null;
  userDelId: number;
  code: string;
  description: string;
  challengeTypeId: number;
  templateSchema: Record<string, any>;
}

export class DistributionList {
  id: number;
  name: string;
  description: string | null;
  flg_preview_list: string | null;
  ts_del: string | null;
  flg_kf: string | null;
  user_ins_id: number | null;
  ts_upd: string | null;
  user_upd_id: number | null;
  user_del_id: number | null;
  flg_dpl: string | null;
  ts_ins: string | null;
  flg_state: string;
}

export class AgreementClusterHead {
  id: number;
  flgState: string;
  flgKf: string;
  flgDeploy: string;
  tsInsert: string;
  userInsertId: number;
  tsUpdate: string | null;
  userUpdateId: number;
  tsDel: string | null;
  userDelId: number;
  cluster: Cluster;
  dateStart: string;
  dateEnd: string;
  description: string;
  dependsOnClusterHeadId: number;
  excludeClusterHeadId: number;
  code: string;
}

export class Cluster {
  id: number;
  flgState: string;
  flgKf: string;
  flgDeploy: string;
  tsInsert: string;
  userInsertId: number;
  tsUpdate: string | null;
  userUpdateId: number;
  tsDel: string | null;
  userDelId: number;
  clusterTypeId: number;
  description: string;
  type: string | null;
  code: string;
}

export class ChallengeType {
  id: number;
  flgState: string;
  flgKf: string;
  flgDeploy: string;
  tsInsert: string;
  userInsertId: number;
  tsUpdate: string | null;
  userUpdateId: number;
  tsDel: string | null;
  userDelId: number;
  code: string;
  description: string;
}


//challengeDetail sono i Livelli
//challenge Detail
export class ChallengeDetail {
  id: number;
  challengeId: number;
  description: string;
  flgDeploy: string;
  flgKf: string;
  flgPushNotification: string;
  flgState: string;
  pushNotificationText: string | null;
  tsInsert: string;
  tsUpdate: string | null;
  tsDel: string | null;
  userInsertId: number;
  userUpdateId: number;
  userDelId: number;
  challengeDetailAcm: ChallengeDetailAcm[];
  menuActivated?: boolean;
  longDescr?:string;
  numRewards: number;
  levelAchievementDate?: string;
  acceptanceDate?: string;
}

export class ChallengeDetailAcm {
  id: number;
  challengeDetailId: number;
  minRangeValue: number;
  maxRangeValue: number;
  flgDeploy: string;
  flgKf: string;
  flgState: string;
  tsInsert: string;   // ISO datetime string
  tsUpdate: string | null;
  tsDel: string | null;
  userInsertId: number;
  userUpdateId: number;
  userDelId: number;
  challengeAcm: any;  // nested oggetto, gestito come any
}



//Livelli elaborati
//DTO per gestire la risposta multipla dei dettagli delle sfide
export class ChallengeDetailElaborated{
    id:number;
    challengeId:number;
    challengeDetailAcmId:number;
    levelName: string;
    controlAcm: number;
    acmDescription:string
    minimumTrashold: number;
    maximumTrashold:number;
    pushNotify:string;
    pushNotifyText:string;
    menuActivated?: boolean;
    numRewards: number;
}



export interface SaveChallengeAcmDto {
  challenge_id: number;
  acm_id: number;
}


export interface SaveChallengeOchannelDto {
  challenge_id: number;
  ochannel_id: number;
  template_value: {
    id: number;
  };
}

export interface SaveChallengeDto {
  title: string;
  description: string;
  date_start: string;               // YYYY-MM-DD
  date_end: string;                 // YYYY-MM-DD
  flg_agreement_required: '0' | '1';
  condition_boolean_operator: 'AND' | 'OR';
  agreement_cluster_head_id: number | null;
  distribution_list_id: number | null;
  challenge_type_id: number;
  template_id: number;
  flg_preview: '0' | '1';
  flg_push_notification: '0' | '1';
  day_offset: number | null;
  time_offset: string | null;       // HH:mm:ss
  push_notification_text: string | null;
  priority: number | null;
  status: string;
  template_value: any;

}

export interface OverviewPartecipantsDTO{
  challengeId: number;
  levelId:number;
  startDate:string;
  endDate:string;
  challengeAcmId: number;
  balanceMax:number;
  balanceMin:number;
}
export interface ParticipantOverviewResponse {
  acceptanceDate: string;          // 2025-10-06
  levelAchievementDate: string;    // 2025-10-08
  firstMovementDate: string;       // 2025-10-07

  acmId: number;
  acmCode: string;

  challengeId: number;
  challengeTitle: string;

  levelId: number;
  levelCode: string;

  customerId: number;
  customerCode: string;
  cardNo: string;
  customerName: string;
  customerSurname: string;

  balance: number;
}
export interface GraphicsDTO{
  challengeId: number;
  startDate:string;
  endDate:string;
   challengeAcmId: any;
}

export interface OverviewPayload {
  searchChallenge: any;
  searchDateStart: Date | null;
  searchEndDate: Date | null;
  acm: any;
  minBalance: number | null;
  maxBalance: number | null;
}

export interface GraphicsDTOChartesian{
  challengeId: number;
  startDate:string;
  endDate:string;
  periodType: string,
  challengeAcmId: any;
}

export interface ParticipantOverview {
  acceptanceDate: string;
  acmId: number;
  levelAchievementDate: string;
  customerCode: string;
  cardNo: string;
  customerName: string;
  customerSurname: string;
  levelCode: string;
  challengeId: number;
  balance: number;
  acmCode: string;
  firstMovementDate: string;
  levelId: number;
  customerId: number;
}

export interface ParticipantsOverviewSummary {
  activeParticipants: number;
  challengeId: number;
  effectiveParticipants: number;
  levelParticipationExclusive: LevelParticipation[];
  challengeTitle: string;
  effectivePercentage: number;
  levelParticipationInclusive: LevelParticipation[];
  activePercentage: number;
  totalParticipants: number;
}

export interface LevelParticipation {
  challengeDetailId: number;
  challengeDetailTitle: string;
  participants: number;
  participantsPercentage: number;
}

export interface LevelParticipationChartesian {
  challengeDetailId: number;
  challengeDetailTitle: string;
  participants: number;
  participantsPercentage: number;
  levelAchievementDate: string | null;
}

export interface ChallengePeriodOverviewChartesian {
  challengeId: number;
  challengeTitle: string;
  periods: PeriodOverviewChartesian[];
}
export interface PeriodOverviewChartesian {
  periodType: string; // es: "MONTH"
  startDate: string; // "2025-09-01"
  endDate: string;   // "2025-09-30"
  totalParticipants: number;
  effectiveParticipants: number;
  activeParticipants: number;
  effectivePercentage: number;
  activePercentage: number;
  levelParticipationExclusive: LevelParticipation[];
  levelParticipationInclusive: LevelParticipation[];
}




export interface NumericResults {
  totalPartecipant: number;
  effectivePartecipant: number;
  effectivePercentage: number;
  activePartecipant: number;
  activePartecipantPercentage: number;
  levels: LevelNumericResult[];
  inclusiveLevels: LevelNumericResult[]
}

export interface LevelNumericResult {
  id: number;
  title: string;
  participants: number;
  percentage: number;
}


export class AcmChallenge extends Acm {
  acmChallengeId?: number;
}


export interface AccumulatorUI extends AccumulatorDTO {
  rowSelected: boolean;
}

export interface ChallengeExportReportDTO {
  id: number;
  challengeId: number;
  fileName: string;
  queryCondition: string;
  mineType: string;
  reportState: string;
  queryCount: number;
  error: string;
}






// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge.model.ts